export function HealthCare(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2 12.2C12.2 11.5373 11.6628 11 11 11C10.3373 11 9.80004 11.5373 9.80004 12.2V13.8H8.20004C7.5373 13.8 7.00004 14.3373 7.00004 15C7.00004 15.6627 7.5373 16.2 8.20004 16.2H9.80004V17.8C9.80004 18.4627 10.3373 19 11 19C11.6628 19 12.2 18.4627 12.2 17.8V16.2H13.8C14.4628 16.2 15 15.6627 15 15C15 14.3373 14.4628 13.8 13.8 13.8H12.2V12.2Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4385 0.800003C15.843 0.800003 17.0752 1.71434 17.4913 3.04054L17.5429 3.22389L18.5772 7.36075C18.7966 7.39322 19.016 7.42711 19.2354 7.46241C20.9717 7.74181 22.1572 9.3701 21.8898 11.1084L20.447 20.4866C20.2068 22.0476 18.8636 23.2 17.2842 23.2H4.71588C3.13645 23.2 1.79325 22.0476 1.55309 20.4866L0.110286 11.1084C-0.15715 9.37009 1.02835 7.74178 2.76475 7.46241C2.98414 7.42711 3.20353 7.39322 3.42292 7.36075L4.45714 3.22389C4.79779 1.86129 5.98366 0.887707 7.37119 0.805623L7.56159 0.800003H14.4385ZM5.97533 7.04658C7.65003 6.88221 9.32498 6.8 11 6.8C12.6751 6.8 14.3501 6.88221 16.0248 7.04658L15.2146 3.80597C15.1345 3.48545 14.8673 3.25103 14.547 3.20735L14.4385 3.2H7.56159C7.23121 3.2 6.93898 3.40237 6.81893 3.70247L6.78548 3.80597L5.97533 7.04658ZM11 9.2C13.6176 9.2 16.2354 9.4106 18.8541 9.83194C19.2882 9.90178 19.5846 10.3089 19.5177 10.7434L18.0749 20.1216C18.0149 20.5119 17.6791 20.8 17.2842 20.8H4.71588C4.32102 20.8 3.98522 20.5119 3.92518 20.1216L2.48238 10.7434C2.41552 10.3089 2.71189 9.90178 3.14599 9.83193C5.76472 9.4106 8.38253 9.2 11 9.2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
